import React, { useState } from 'react';
import { STORAGE_ACTION, setStorageItem } from '@utils/storage';
import { useMediaQuery, useTheme } from '@material-ui/core';
import getContents from './updateNoticeContents';
import UpdateNoticeModalPresenter from './UpdateNoticeModalPresenter';
import { IUpdateModalState } from '@components/App/useNoticeSchedule';
import { format } from 'date-fns';

interface UpdateNoticeModalPresenterProps {
  updateModalState: IUpdateModalState;
}

const UpdateNoticeModalContainer = ({
  updateModalState
}: UpdateNoticeModalPresenterProps) => {
  const matches = useMediaQuery(useTheme().breakpoints.down('xs'));
  const { startTime, endTime, modalType, isOpenInit } = updateModalState;

  const [isOpen, setIsOpen] = useState(isOpenInit);

  const content = getContents(matches)[modalType];

  const startTimeString = format(
    new Date(startTime.replace(' ', 'T')),
    'yyyy년 MM월 dd일 HH시 mm분'
  );

  let endTimeString = format(new Date(endTime.replace(' ', 'T')), 'HH시 mm분');

  if (startTime.split(' ')[0] !== endTime.split(' ')[0]) {
    endTimeString = format(
      new Date(endTime.replace(' ', 'T')),
      'yyyy년 MM월 dd일 HH시 mm분'
    );
  }

  const onClick = () => {
    setIsOpen(false);
    const valueToJSONString = JSON.stringify({
      isNotSeeAgain: true,
      startTime,
      endTime,
      modalType
    });
    setStorageItem(STORAGE_ACTION.NOT_SEEING_AGAIN_NOTICE, valueToJSONString);
  };

  return (
    <UpdateNoticeModalPresenter
      modalType={modalType}
      isOpen={isOpen}
      content={content}
      startTimeString={startTimeString}
      endTimeString={endTimeString}
      onClick={onClick}
      onClose={() => setIsOpen(false)}
    />
  );
};

export default UpdateNoticeModalContainer;
